import { useCallback, useEffect, useRef } from "react";
import { formatDate } from "../../utils/common";

function ProductListMobile({
  data,
  totalCount,
  currentPage,
  pageSize,
  onPageChange,
  resend,
  cancel,
}) {
  const loader = useRef(null);
  const hasMore = data.length < totalCount;

  const observerCallback = useCallback(
    (entries) => {
      const target = entries[0];
      if (target.isIntersecting && hasMore) {
        onPageChange(currentPage + 1);
      }
    },
    [currentPage, hasMore, onPageChange]
  );

  useEffect(() => {
    const observer = new IntersectionObserver(observerCallback, {
      threshold: 1.0,
    });

    const currentLoader = loader.current;
    if (currentLoader) {
      observer.observe(currentLoader);
    }

    return () => {
      if (currentLoader) {
        observer.unobserve(currentLoader);
      }
    };
  }, [observerCallback]);

  return (
    <>
      <ul className="product-list-mobile">
        {data.map((item, i) => {
          return (
            <li className="box" key={i}>
              <dl>
                <dt>쿠폰번호</dt>
                <dd>
                  <span>{item.serialNumber}</span>
                </dd>
              </dl>
              <dl>
                <dt>구매일자</dt>
                <dd>{formatDate(item.regDate)}</dd>
              </dl>
              <dl>
                <dt>유형</dt>
                <dd>{item.name}</dd>
              </dl>
              <dl>
                <dt>사용유무</dt>
                <dd>
                  {item.is_used === "Y" ? (
                    <span className="success-use">사용완료</span>
                  ) : (
                    <span className="not-use">미사용</span>
                  )}
                </dd>
              </dl>
              <div>
                {item.isUsed === "N" && (
                  <button
                    className="resend"
                    onClick={() => {
                      resend(item.couponsSeq);
                    }}
                  >
                    재발송
                  </button>
                )}
                {item.status === "completed" &&
                  item.paymentMethod !== "free" && (
                    <button
                      className="resend"
                      onClick={() => {
                        cancel(item.orderId, "고객 취소 신청");
                      }}
                    >
                      취소
                    </button>
                  )}
              </div>
            </li>
          );
        })}
      </ul>
      {hasMore && <div ref={loader} style={{ height: "30px" }} />}
    </>
  );
}

export default ProductListMobile;
